import { render, staticRenderFns } from "./schoolContactUsDetail.vue?vue&type=template&id=bae6bc46"
import script from "./schoolContactUsDetail.vue?vue&type=script&lang=js"
export * from "./schoolContactUsDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports